import General from 'dash/js/services/General'

/**
 * @param {*} param0
 * @param {*} values
 */
export const retrieveJadlogAgencies = async ({ commit }, values) => {
  const payload = Object.assign({
    country: 'BR'
  }, values)

  await General.retrieveJadlogAgencies(payload, response => commit('retrieveJadlogAgencies', response.data))
}

/**
 * @param {*} param0
 * @param {*} data
 */
export const updateFilters = ({ commit }, data) => {
  commit('updateFilters', data)
}

/**
 * @param {*} param0
 */
export const changeModalStatus = ({ commit }) => {
  commit('changeModalStatus')
}

/**
 * @param {*} param0
 * @param {*} data
 */
export const changeSidebarStatus = ({ commit }, data) => {
  commit('changeSidebarStatus', data)
}
